import React from 'react';
import PageDocumentTitle from '../PageDocumentTitle';
import PageHeader from '../PageHeader';
import PageRoot from '../PageRoot';
import PageShell from '../PageShell';

export default function SingleTablePageLayout({
    documentTitle,
    title,
    headerMeta,
    filters,
    children,
}) {
    return (
        <PageRoot variant="singleTable">
            <PageDocumentTitle title={documentTitle} />
            <PageShell variant="singleTable">
                <PageHeader title={title} headerMeta={headerMeta} />
                {filters}
                {children}
            </PageShell>
        </PageRoot>
    );
}
